import "core-js/modules/es.array.push.js";
import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import axios from "axios";
import { api } from "@/api/api";
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import router from '@/router';
import { showConfirmDialog } from 'vant';
export default {
  name: 'member_upload_push_m',
  setup() {
    const route = useRoute();
    console.log(route.query);
    const hd_data = ref({
      ...route.query
    });
    console.log(hd_data.value);
    const push_data = ref({
      textarea: '',
      img: '',
      vido: ''
    });
    const vido_img = ref('');
    // 用户信息
    const user_info = ref(JSON.parse(localStorage.getItem('userData')));
    // 上传图片
    const afterReadImg = file => {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const formData = new FormData();
      formData.append('file', file.file);
      const url = api.baseUrl + api.uploadIcon;
      axios.post(url, formData).then(res => {
        console.log(res);
        push_data.value.img = res.data.data.url;
      });
    };
    // 上传视频
    const afterReadVido = file => {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const formData = new FormData();
      formData.append('file', file.file);
      const url = api.baseUrl + api.uploadVideo;
      axios.post(url, formData).then(res => {
        console.log(res);
        push_data.value.vido = res.data.data.url;
        vido_img.value = res.data.data.img_url;
      });
    };
    // 提交
    const tj = () => {
      console.log(push_data.value);
      if (!push_data.value.textarea || push_data.value.img == '' && push_data.value.vido == '') {
        ElMessage({
          message: !push_data.value.textarea ? '请填写备注' : !push_data.value.img ? '请上传图片' : '请上传视频',
          type: 'error',
          customClass: "message-m"
        });
        return;
      }
      axios({
        url: api.baseUrl + api.insertRecord,
        method: 'post',
        data: {
          userId: user_info.value.id,
          benefitId: 2,
          materialId: hd_data.value.id,
          imageUrl: push_data.value.img,
          videoUrl: push_data.value.vido,
          remark: push_data.value.textarea
        }
      }).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          if (hd_data.value.uploadFlow - hd_data.value.doneFlow != 1) {
            ElMessage({
              message: res.data.msg,
              type: 'success',
              customClass: "message-m"
            });
            fh();
          } else {
            showConfirmDialog({
              title: '恭喜打卡完成',
              message: hd_data.value.finishedMessage,
              showCancelButton: false,
              confirmButtonColor: '#41B8B2'
            }).then(() => {
              fh();
            });
          }
        } else {
          ElMessage({
            message: res.data.msg,
            type: 'error',
            customClass: "message-m"
          });
        }
      });
    };
    const fh = () => {
      router.go(-1);
    };
    const delete_click = key => {
      delete push_data.value[key];
    };
    const look = () => {
      window.open(push_data.value.vido);
    };
    // 查看历史记录
    const history = () => {
      router.push({
        name: 'member_history_m',
        query: {
          ...hd_data.value
        }
      });
    };
    return {
      push_data,
      afterReadVido,
      afterReadImg,
      hd_data,
      tj,
      fh,
      delete_click,
      vido_img,
      look,
      history
    };
  }
};